<!--<h2 mat-dialog-title>{{"CROSSWORD.instruction_title" | translate }}</h2>-->
<ion-header>
  <ion-toolbar>
    <ion-title>{{("ANALYTICS.privacy_dialog.title" | translate) }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-item lines="none">
          <ion-text>
            {{ "ANALYTICS.privacy_dialog.message" | translate }}
          </ion-text>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-item lines="none">
          <ion-text>
            {{ "ANALYTICS.privacy_dialog.privacy_policy_message" | translate }}
          </ion-text>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row class="privacy-statement">
      <ion-item lines="none">
        <iframe [src]="privacyUrl" class="puzzle-elevation-z3"></iframe>
      </ion-item>
    </ion-row>
    <ion-row *ngIf="requestConsent">
      <ion-item lines="none" class="privacy-checkbox">
        <ion-checkbox
          #input
          labelPlacement="end"
          color="primary"
          class="puzzle-analytics-consent"
          [(ngModel)]="localConsent"
        >
          <span *ngIf="analytics.enabled" class="ion-text-wrap">
            {{ "PUZZLE.welcome_dialog.analytics_consent_message.text_with_analytics" | translate }}
          </span>
          <span *ngIf="!analytics.enabled" class="ion-text-wrap">
            {{ "PUZZLE.welcome_dialog.analytics_consent_message.text_without_analytics" | translate }}
          </span>
        </ion-checkbox>
      </ion-item>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <div class="puzzle-modal-buttons">
    <ion-button
      [disabled]="requestConsent && !localConsent && !globalConsent"
      (click)="closeDialog()"
    >
      {{"ANALYTICS.privacy_dialog.close_button" | translate}}
    </ion-button>
  </div>
</ion-footer>


